function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.25,
  fill: "white",
  stroke: "#0A0806",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7511 24.6614C23.8218 24.6614 24.6897 23.7934 24.6897 22.7228C24.6897 21.6521 23.8218 20.7842 22.7511 20.7842C21.6804 20.7842 20.8125 21.6521 20.8125 22.7228C20.8125 23.7934 21.6804 24.6614 22.7511 24.6614Z",
  stroke: "#0A0806",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3972 15.2276L24.9684 17.1054C25.1635 17.752 25.8262 18.1367 26.4844 17.9856L28.3881 17.5435C29.1286 17.3767 29.8913 17.7119 30.2692 18.3701C30.6471 19.0284 30.552 19.856 30.0346 20.4114L28.7035 21.8473C28.2421 22.3433 28.2421 23.1114 28.7035 23.6075L30.0346 25.0434C30.5528 25.5983 30.6484 26.4264 30.2702 27.0848C29.892 27.7432 29.1286 28.0779 28.3881 27.9099L26.4844 27.4692C25.8261 27.3173 25.1629 27.7024 24.9684 28.3493L24.3972 30.2194C24.1784 30.9463 23.509 31.4438 22.75 31.4438C21.991 31.4438 21.3216 30.9463 21.1028 30.2194L20.5316 28.3429C20.3371 27.6959 19.6739 27.3109 19.0156 27.4627L17.1119 27.9035C16.3714 28.0715 15.608 27.7368 15.2298 27.0784C14.8516 26.42 14.9472 25.5919 15.4654 25.0369L16.7965 23.601C17.2579 23.105 17.2579 22.3369 16.7965 21.8408L15.4654 20.4049C14.948 19.8496 14.8529 19.0219 15.2308 18.3637C15.6087 17.7054 16.3714 17.3703 17.1119 17.5371L19.0156 17.9791C19.6738 18.1303 20.3365 17.7455 20.5316 17.099L21.1028 15.2211C21.3231 14.4947 21.9934 13.9985 22.7524 14C23.5114 14.0015 24.1798 14.5003 24.3972 15.2276Z",
  stroke: "#0A0806",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgOperatorFormIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "operator-form-icon",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOperatorFormIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/operator-form-icon.49289d32.svg";
export { ForwardRef as ReactComponent };